import React from "react";

// Mui Styles
// import { styled } from "@mui/material/styles";
import { ThemeProvider } from "@mui/material/styles";
import { StyledPaper } from "@/styles/mui/globalStyles";
import { TableListTheme } from "@/styles/mui/tableListTheme";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";

// Navigate
import { useNavigate } from "react-router-dom";

// Components
import Layout from "@/components/layout";
import Title from "@/components/title";
import { PushNotificationTableColumn } from "@/config/tableColumnConfig";
import DataTable from "@/components/dataTable";

// Mui Icon
import IconButton from "@mui/material/IconButton";
import { AddOutlined } from "@mui/icons-material";

// Fetch
import { getPushNotificationByUser } from "@/fetch/fetchNotice";

const PushNotificationPage = (props) => {
  const { open, setOpen } = props;

  // Navigate
  const navigate = useNavigate();

  // States
  const [pushNoticeData, setPushNoticeData] = React.useState([]);
  const [snackMessage, setSnackMessage] = React.useState("");
  const [snackOpen, setSnackOpen] = React.useState(false);
  const [snackSeverity, setSnackSeverity] = React.useState("");
  const [dataTableLoading, setDataTableLoading] = React.useState(false);

  const onCellClick = (data) => {
    if (data.field === "__check__") return;
    if (data.row.status !== "pending") {
      setSnackMessage("不能修改");
      setSnackSeverity("error");
      setSnackOpen(true);
      return;
    } else {
      navigate(`edit/${data.id}`);
    }
  };

  const onAddClick = () => {
    navigate("create/");
  };

  // Fetch
  const fetchAll = async () => {
    try {
      setDataTableLoading(true);
      await getPushNotificationByUser().then((data) => {
        if (data && data.results) setPushNoticeData(data.data);
      });
    } catch (error) {
    } finally {
      setDataTableLoading(false);
    }
  };

  React.useEffect(() => {
    fetchAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout
      open={open}
      selectedIndex={17}
      header="workLocationManagePage"
      snackOpen={snackOpen}
      snackClose={() => setSnackOpen(false)}
      snackMessage={snackMessage}
      snackSeverity={snackSeverity}
      setOpen={setOpen}
    >
      <Title
        title="推播通知"
        history={() => navigate(-1)}
        children={
          <div>
            {/* Add Record */}
            <IconButton component="label" onClick={onAddClick}>
              <AddOutlined />
            </IconButton>
          </div>
        }
      />
      <StyledPaper page={"yes"}>
        <ThemeProvider theme={TableListTheme}>
          <DataTable
            loading={dataTableLoading}
            rows={pushNoticeData}
            onCellClick={(params) => onCellClick(params)}
            columns={PushNotificationTableColumn}
            pageSize={100}
            initialState={{
              sorting: {
                sortModel: [{ field: "time_created", sort: "desc" }],
              },
            }}
          />
        </ThemeProvider>
      </StyledPaper>
    </Layout>
  );
};

export default PushNotificationPage;
